import styled, { keyframes } from "styled-components";

const ropecut = keyframes`
  0% {transform: rotateZ(0deg);transform-origin: top right;animation-timing-function: ease-in-out;}
  50% {transform: rotateZ(-7.5deg);transform-origin: top right;animation-timing-function: ease-in-out;}
  100% {animation-timing-function: ease-in-out; transform-origin: top right;}
`;

const swingdown = keyframes`
  0% {
    opacity: .99999;
    transform: rotateX(90deg);
  }

  30% {			
    transform: rotateX(-20deg) rotateY(5deg);
    animation-timing-function: ease-in-out;
  }

  65% {
    transform: rotateX(20deg) rotateY(-3deg);
    animation-timing-function: ease-in-out;
  }

  100% {
    transform: rotateX(0);
    animation-timing-function: ease-in-out;
  }
`;

const swingdown2 = keyframes`
  0% {
    opacity: .99999;
    transform: rotateX(10deg);
  }

  30% {			
    transform: rotateX(-30deg);
    animation-timing-function: ease-in-out;
  }

  65% {
    transform: rotateX(20deg);
    animation-timing-function: ease-in-out;
  }

  100% {
    transform: rotateX(0);
    animation-timing-function: ease-in-out;
  }
`;

export const Navbar = styled.div`
  width: 100%;
  height: 50px;
  background-color: #005a24;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 1px 6px #d7d7d7;
  z-index: 100;
  position: absolute;
`;

export const AppContainer = styled.div`
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const ElementContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 250px;
`;

export const NavbarRightDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 400px;
`;

export const NavbarButton = styled.button`
  padding: 5px 10px;
  outline: none;
  background-color: white;
  border: 1px solid #d7d7d7;
  border-radius: 2px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 30px;
  margin-left: 17px;
  &:hover {
    background-color: rgb(213, 213, 213) !important;
  }
`;

export const NavbarLabel = styled.label`
  width: 100%;
  height: 100%;
  max-width: 200px;
  outline: none;
  border: none;
  background-color: #005a24;
  color: white;
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: bold;
`;

export const NavbarTitle = styled.label`
  margin: 0px 30px;
  font-weight: bold;
  font-size: 18px;
  color: #5e5c5c;
`;

export const Banner = styled.div`
  width: 80vw;
  height: 60px;
  background: #ffe7a5;
  margin: 10px;
  position: absolute;
  top: 42px;
  animation: ${ropecut} 1.2s linear, ${swingdown} 1.2s linear,
    ${swingdown2} 4s linear infinite;
  transform: rotateZ(0);
  transform-origin: top left;
  animation-timing-function: ease-in-out;
  transform: translateY(50px);
  box-shadow: 0px 1px 2px #d7d7d7;
  animation-delay: 0s, 0s, 1.2s;
  z-index: 2;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
`;

export const BannerText = styled.div`
  text-align: initial;
  color: #06ac38;
  font-size: 24px;
  margin-left: 10px;
`;

export const BannerShadow = styled.div`
  width: 80vw;
  height: 60px;
  background: #c1c1c1a3;
  margin: 10px;
  position: absolute;
  top: 42px;
  box-shadow: 0px 4px 5px #c1c1c1a3;
  animation: ${ropecut} 1.2s linear, ${swingdown} 1.2s linear;
  transform: rotateZ(0);
  transform-origin: top left;
  animation-timing-function: ease-in-out;
  box-shadow: 0px 1px 2px #d7d7d7;
  animation-delay: 0s, 0s;
`;

export const AvatarContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 55px;
  margin: 10px;
`;

export const AvatarContainerMini = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  background-color: white;
  border-radius: 5px;
  border: 1px solid;
  box-shadow: inset 0 0 10px #8b8b8b;
`;

export const ContainerBodyMini = styled.div`
  position: absolute;
  right: 7px;
  top: 3px;
`;

export const ContainerEyes = styled.div`
  position: absolute;
  right: 5px;
  top: 9px;
  z-index: 3;
`;

export const ContainerMouthMini = styled.div`
  top: 28px;
  right: 3px;
  position: absolute;
  z-index: 0;
`;

export const FAQ = styled.div`
  position: absolute;
  bottom: 10px;
  right: 20px;
  color: gray;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorModalContainer = styled.div`
  margin: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const ErrorModalTitle = styled.div`
  color: rgb(248, 36, 49);
  font-size: 30px;
`;

export const ErrorModalSubtitle = styled.div`
  font-size: 18px;
`;

export const ErrorModalTextContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

export const ErrorModalButton = styled.button`
  padding: 10px 20px;
  outline: none;
  background-color: white;
  border: 1px solid rgb(215, 215, 215);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 30px;
  margin-left: 30px;
  font-size: 20px;
  &:hover {
    background-color: rgb(213, 213, 213) !important;
  }
`;

export const FeedbackIcon = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const FeedbackSpan = styled.span`
  font-weight: bold;
  color: rgb(6, 172, 56);
`;

export const FeedbackButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding: 10px 15px;
  border: 1px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 105px;
  gap: 5px;

  &:hover {
    color: rgb(6, 172, 56);
    border: 1px solid rgb(6, 172, 56);
  }
`;
export const FeedbackTextArea = styled.textarea`
  outline: none;
  margin: 10px 0px;
  display: block;
  width: calc(100% - 26px);
  padding: 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.2rem;

  &:hover {
    border: 1px solid #8b8b8b;
  }
`;

export const FeedbackTextareaDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: calc(100% - 40px);

  &: textarea {
    margin: 20px;
    width: calc(100% - 40px);
    border: 1px solid #808080b5;
    border-radius: 5px;
    padding: 20px;
  }
`;

export const FeedbackSubmitButton = styled.button`
  background-color: rgb(6, 172, 56);
  padding: 10px 20px;
  color: white;
  border-radius: 5px;
  outline: none;
  margin-right: 15px;
  border: 1px solid rgb(6, 172, 56);

  &:disabled {
    background-color: #e7e7e7 !important;
    border: 1px solid #e1e1e1;
  }
`;

export const FeedbackCloseButton = styled.button`
  background-color: #ffffff;
  padding: 10px 20px;
  color: rgb(6, 172, 56);
  border-radius: 5px;
  outline: none;
  margin-right: 15px;
  border: 1px solid #afafaf;

  &:disabled {
    background-color: #e7e7e7 !important;
    border: 1px solid #e1e1e1;
  }
`;
export const TourButton = styled.button`
padding: 10px 20px;
border-radius: 5px;
outline: none;
margin-right: 15px;
border: 1px solid #afafaf;
cursor: pointer;
background-color: rgb(6, 172, 56);
color: white;

&:hover {
  background-color: #ffffff;
    color: rgb(6, 172, 56);
  }
`;

export const FeedbackDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  color: black;
  gap: 15px;
`;

export const MigrationModalContainer = styled.div`
  margin: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  max-width: 600px;
`;

export const MigrationModalTitle = styled.div`
  color: rgb(6, 172, 56);
  font-size: 28px;
  font-weight: bold;
  text-align: center;
`;

export const MigrationModalText = styled.div`
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
  color: #333;
`;

export const MigrationModalLink = styled.a`
  color: rgb(6, 172, 56);
  font-weight: bold;
  font-size: 18px;
  text-decoration: none;
  padding: 10px 20px;
  border: 2px solid rgb(6, 172, 56);
  border-radius: 5px;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(6, 172, 56);
    color: white;
  }
`;

export const MigrationModalDate = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: rgb(6, 172, 56);
  margin-top: 10px;
`;

export const MigrationModalButton = styled.button`
  padding: 10px 20px;
  outline: none;
  background-color: rgb(6, 172, 56);
  color: white;
  border: 1px solid rgb(6, 172, 56);
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;

  &:hover {
    background-color: rgb(5, 150, 48);
  }
`;
